import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Card } from "@ui/components/containers/card";
import { row } from "@ui/components/layout";

interface CategoriesViewProps extends React.HTMLAttributes<HTMLDivElement> {
	tags: string[];
	showAll?: boolean;
	onItemClick?: (cat: string) => void;
	selectedTag?: string;
	withoutTranslation?: boolean;
	applyWording?: (value: string) => string;
}
export const TagsView: React.FC<CategoriesViewProps> = ({
	withoutTranslation = false,
	applyWording,
	tags,
	selectedTag,
	showAll,
	onItemClick,
	...htmlProps
}) => (
	<Container {...htmlProps}>
		{tags.map((tag) => (
			<TagView
				key={tag}
				onMouseDown={() => onItemClick?.(tag)}
				clickable={!!onItemClick}
				selected={tag === selectedTag}
			>
				{applyWording ? applyWording(tag) : !withoutTranslation ? I18n.t(`tag.${tag}`) : tag}
			</TagView>
		))}
	</Container>
);

const Container = styled.div`
	${row(30, "flex-start", "center")};
	flex-wrap: wrap;
`;

const TagView = styled(Card).withConfig({
	shouldForwardProp: (prop) => !["clickable", "isExpander", "selected"].includes(prop),
})<{ clickable?: boolean; isExpander?: boolean; selected?: boolean }>`
	${({ theme }) => theme.textStyles.light};
	cursor: ${({ clickable, isExpander }) => (clickable || isExpander ? "pointer" : "default")};
	margin-bottom: 2px;
	padding: 0.5rem 1.25rem;
	font-size: 0.875rem;
	font-weight: 400;
	color: ${({ theme, selected }) => selected && theme.colors.secondary};
`;
